<div class="rps-paragraph-one">
  <p [innerHTML]="marketHoldingTermsDisclaimer?.contentValue"></p>
  <div class="buttons">
    <c11n-button [buttonType]="'button'" [size]="'medium'" [variant]="'primary'" [labelText]="'Accept'"
      (clickEvent)="userAccepted()" class='padded-btn'></c11n-button>
    <c11n-button [buttonType]="'button'" [size]="'medium'" [variant]="'secondary'" [labelText]="'Do not accept'"
      (clickEvent)="userDeclined()"></c11n-button>
  </div>
</div>